import dotenv from 'dotenv';
dotenv.config();

export const BaseURL = process.env.REACT_APP_BACKEND_URL